import React from "react";
import { FaCog, FaMapMarkerAlt, FaTag, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

function SparePartsDetails({ product }) {
    if (!product) return <p className="productspec-error">Məhsul detalları yüklənmir...</p>;

    const specs = [
        { label: "Ad", value: product.name, icon: <FaCog /> },
        { label: "Qiymət", value: product.price ? `${product.price} AZN` : null },
        { label: "Şəhər", value: product.city, icon: <FaMapMarkerAlt /> },
        { label: "Kateqoriya", value: product.categoryName, icon: <FaTag /> },
        { label: "Sub-kateqoriya", value: product.subCategoryName },
        { label: "Hissə Növü", value: product.partType },
        { label: "Vəziyyəti", value: product.condition },
        { label: "Bitmə tarixi", value: product.endDate ? new Date(product.endDate).toLocaleString("tr-TR") : null }
    ];

    return (
        <div className="productspec-container productspec-container--automotive">
            <div className="productspec-header">
                <FaCog className="productspec-header__icon" />
                <h3 className="productspec-header__title">Ehtiyat Hissəsi Məlumatları</h3>
            </div>

            <div className="productspec-grid">
                {specs.map((spec, index) => {
                    if (!spec.value || spec.value === "Bilinmir" || spec.value === "Qiymət mövcud deyil") return null;
                    
                    return (
                        <div key={index} className="productspec-item">
                            {spec.icon && <span className="productspec-item__icon">{spec.icon}</span>}
                            <div className="productspec-item__content">
                                <span className="productspec-item__label">{spec.label}</span>
                                <span className="productspec-item__value">
                                    {spec.value}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {product.description && (
                <div className="productspec-description">
                    <h4 className="productspec-description__title">Əlavə Təsvir</h4>
                    <p className="productspec-description__text">{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default SparePartsDetails;